import { useEffect, useState } from "react";
import { DismissIcon } from "../../materials/icons/dismiss-icon/DismissIcon";
import { Body } from "../body/Body";
import { IconButton } from "../icon-button/IconButton.Parts";
import { Container, Content, Icon, Props } from "./Alert.Parts";

export const Alert = ({ title, message, dismissible = false }: Props) => {
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => setIsDismissed(false), [title, message]); // reset dismissal when content changes

  if (isDismissed) return null;
  if (!title && !message) return null;

  return (
    <Container>
      <Icon />
      <Content>
        {title && <Body variant="normal-strong">{title}</Body>}
        {message && <Body>{message}</Body>}
      </Content>
      {dismissible && (
        <IconButton
          $height="auto"
          $width="auto"
          onClick={() => setIsDismissed(true)}
        >
          <DismissIcon small={true} />
        </IconButton>
      )}
    </Container>
  );
};
